import { useAppSelector } from "../../../../../hooks/store-hooks";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Box,
  Typography,
  AccordionDetails,
  Grid,
  IconButton,
  Divider,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useRecortesExtracaoService } from "../../../../../../use-cases/geo-veles";
import { RecorteCBOFilterPreview } from "./cbo";
import { RecorteClasseSocialFilterPreview } from "./classe-social";
import { RecorteContatoFilterPreview } from "./contato";
import { RecorteDataNascimentoFilterPreview } from "./data-nascimento";
import { RecorteEscolaridadeFilterPreview } from "./escolaridade";
import { RecorteEstadoCivilFilterPreview } from "./estado-civil";
import { RecorteIdadeFilterPreview } from "./idade";
import { RecorteListaCEPFilterPreview } from "./listas-cep";
import { RecorteLocalizacaoFilterPreview } from "./localizacao";
import { RecorteProfissaoFilterPreview } from "./profissao";
import { RecorteRendaAnualFilterPreview } from "./renda-anual";
import { RecorteRendaMensalFilterPreview } from "./renda-mensal";
import { RecorteScoreFilterPreview } from "./score";
import { RecorteSexoFilterPreview } from "./sexo";
import { theme } from "../../../../../styles";
import {
  quantidadeRecorteToLabel,
  recorteAvailableToLabel,
} from "../../../../../../utils";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";

import { RecorteListasDeduplicacaoFilterPreview } from "./listas-deduplicacao";
import { useEffect, useState } from "react";
import { EditRecorteProjetoForm } from "../edit-recorte-projeto-form";
import {
  IRecorte,
  IRecorteExtracao,
} from "../../../../../../application/models";
import { ListasCidadesFilterPreview } from "../../detalhes-do-projeto/filtros/localizacao/lista-cidades/forms/listaCidadesFilterPreview";
import { RecorteListasCboPreview } from "../create-recorte-projeto-form/listas-cbo/RecorteListasCboPreview";
import { ListasCboFilterPreview } from "../../detalhes-do-projeto/filtros/cbo/forms/ListasCboFilterPreview";

interface RecortesProjetoListProps {
  temRecorteExtracao?: IRecorteExtracao;
  modoSomenteLeitura?: boolean;
}

export const RecortesProjetoList = ({
  temRecorteExtracao,
  modoSomenteLeitura,
}: RecortesProjetoListProps) => {
  const reduxState = useAppSelector((state) => state.recorteExtracao);
  //const finalRecorteExtracao = temRecorteExtracao!
  const finalRecorteExtracao = temRecorteExtracao ?? reduxState;

  // State
  const {
    recorteExtracao,
    recorteErrors,
    recortesDisponiveis,
    openForm,
    editOpenForm,
    indexRecorte,
    editRecorteExtracaoForm,
  } = useAppSelector((state) => state.recorteExtracao);
  const {
    removeRecorte,
    openEditRecorteForm,
    closeEditRecorteForm,
    setRecortesAtuais,
    setEditRecorteForm,
    resetIndexRecorte,
    resetEditRecorteForm,
  } = useRecortesExtracaoService();

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [recorteToRemove, setRecorteToRemove] = useState<IRecorte | null>(null);
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    false
  );
  const [triggeredByEdit, setTriggeredByEdit] = useState(false);
  const handleExpandClick = (panel: string) => {
    setExpandedAccordion((prev) => {
      if (triggeredByEdit && prev === panel) return prev;
      return prev === panel ? false : panel;
    });
    setTriggeredByEdit(false);
  };

  useEffect(() => {
    resetIndexRecorte();
    resetEditRecorteForm();
    closeEditRecorteForm(false);
  }, []);

  if (
    !("Recortes" in finalRecorteExtracao) ||
    !finalRecorteExtracao.Recortes?.length
  )
    return null;

  return (
    <>
      {finalRecorteExtracao?.Recortes?.map((recorte, i) => {
        //const isExpanded = expandedAccordion === recorte.Nome;

        return (
          <Accordion
            key={recorte.Nome}
            expanded={expandedAccordion === recorte.Nome}
            sx={{
              my: 1,
              border: recorteErrors
                ? recorteErrors.find((r) => r.nome === recorte.Nome)
                  ? "2px solid #ff0000"
                  : recortesDisponiveis &&
                    recortesDisponiveis.find((r) => r.nome === recorte.Nome) &&
                    "2px solid #00c732"
                : null,
              backgroundColor:
                i % 2 === 0
                  ? theme.palette.mode === "light"
                    ? theme.palette.grey[50]
                    : theme.palette.grey[900]
                  : theme.palette.background.default,
            }}
          >
            <AccordionSummary
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                position: "relative",
                cursor: "default",
              }}
            >
              <Box sx={{ width: "100%" }}>
                <Grid
                  container
                  display="flex"
                  alignItems="center"
                  justifyContent="left"
                >
                  <Grid item xs={4} sx={{ textAlign: "center" }}>
                    <Typography
                      textAlign="center"
                      sx={{ fontWeight: "bold", flexShrink: 0 }}
                    >
                      {recorte.Nome}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ textAlign: "center" }}>
                    <Typography
                      textAlign="left"
                      sx={{ color: "text.secondary", flexShrink: 0 }}
                    >
                      <strong>
                        {recorte.Quantidade.toLocaleString("pt-BR")}
                      </strong>
                      {` ${quantidadeRecorteToLabel(recorte.Quantidade)}`}

                      <strong>
                        {recorteErrors &&
                          recorteErrors.find((r) => r.nome === recorte.Nome) &&
                          ` | ${recorteAvailableToLabel(
                            recorteErrors.find((r) => r.nome === recorte.Nome)
                              ?.totalAvailable ?? 0
                          )}`}
                      </strong>

                      <strong>
                        {recortesDisponiveis &&
                          recortesDisponiveis.find(
                            (r) => r.nome === recorte.Nome
                          ) &&
                          ` | ${recorteAvailableToLabel(
                            recortesDisponiveis.find(
                              (r) => r.nome === recorte.Nome
                            )?.totalAvailable ?? 0
                          )}`}
                      </strong>

                      {recorte.Filtros
                        ? Object.keys(recorte.Filtros).length === 0
                          ? " | Nenhum filtro selecionado"
                          : Object.keys(recorte.Filtros).length === 1
                          ? " | 1 filtro selecionado"
                          : ` | ${Object.keys(
                              recorte.Filtros
                            ).length.toLocaleString(
                              "pt-BR"
                            )} filtros selecionados`
                        : " | Nenhum filtro selecionado"}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              {!modoSomenteLeitura && (
                <Box
                  sx={{
                    position: "absolute",
                    right: "70px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <Tooltip
                    title={
                      editOpenForm &&
                      recorteExtracao.Recortes[indexRecorte ?? 0]
                        ? "Cancelar edição"
                        : "Editar recorte"
                    }
                  >
                    <IconButton
                      aria-label={
                        editOpenForm && indexRecorte === i ? "cancel" : "edit"
                      }
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();

                        const recorteAtual = editOpenForm && indexRecorte === i;

                        // Se já está editando este mesmo recorte, então cancela
                        if (recorteAtual) {
                          resetIndexRecorte();
                          closeEditRecorteForm(false);
                          return;
                        }

                        // Se está editando outro recorte, fecha ele ANTES de abrir o novo
                        if (editOpenForm && indexRecorte !== i) {
                          resetIndexRecorte();
                          closeEditRecorteForm(false);
                        }

                        // Agora inicia edição do novo recorte
                        setEditRecorteForm(editRecorteExtracaoForm.fields);
                        //obterIndex(); // Presumo que isso defina o index de edição
                        setTriggeredByEdit(true);

                        openEditRecorteForm({
                          openForm: true,
                          recorte: recorte,
                          index: i,
                        });

                        setRecortesAtuais(recorteExtracao);

                        if (
                          !expandedAccordion ||
                          expandedAccordion !== recorte.Nome
                        ) {
                          handleExpandClick(recorte.Nome);
                        }
                      }}
                    >
                      {editOpenForm && indexRecorte === i ? (
                        <CancelIcon fontSize="small" />
                      ) : (
                        <EditIcon fontSize="small" />
                      )}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Excluir recorte">
                    <IconButton
                      aria-label="delete"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setRecorteToRemove(recorte);
                        setOpenConfirmDialog(true);
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              <Box
                sx={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    handleExpandClick(recorte.Nome);
                  }}
                >
                  <ExpandMoreIcon />
                </IconButton>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {openForm && editOpenForm && indexRecorte === i ? (
                <Grid item xs={12} display={"flex"} mt={2}>
                  <EditRecorteProjetoForm />
                </Grid>
              ) : (
                <>
                  {Object.keys(recorte.Filtros ?? {}).length > 0 && (
                    <Grid container>
                      <Grid item xs={12} mb={5}>
                        <Divider
                          variant="fullWidth"
                          color={theme.palette.primary.main}
                        />
                      </Grid>
                      <Grid container display="flex" alignItems="center">
                        {recorte.Filtros?.cbo && (
                          <RecorteCBOFilterPreview
                            cboFilter={recorte.Filtros.cbo}
                          />
                        )}

                        {recorte.Filtros?.listasCbo && (
                          <ListasCboFilterPreview
                            listasCboFilterPreview={recorte.Filtros.listasCbo}
                          />
                        )}
                        
                        {recorte.Filtros?.classeSocial && (
                          <RecorteClasseSocialFilterPreview
                            classeSocialFilter={recorte.Filtros.classeSocial}
                          />
                        )}
                        {recorte.Filtros?.contato && (
                          <RecorteContatoFilterPreview
                            contatoFilter={recorte.Filtros.contato}
                          />
                        )}
                        {recorte.Filtros?.dataNascimento && (
                          <RecorteDataNascimentoFilterPreview
                            dataNascimentoFilter={
                              recorte.Filtros.dataNascimento
                            }
                          />
                        )}
                        {recorte.Filtros?.escolaridade && (
                          <RecorteEscolaridadeFilterPreview
                            escolaridadeFilter={recorte.Filtros.escolaridade}
                          />
                        )}
                        {recorte.Filtros?.estadoCivil && (
                          <RecorteEstadoCivilFilterPreview
                            estadoCivilFilter={recorte.Filtros.estadoCivil}
                          />
                        )}
                        {recorte.Filtros?.idade && (
                          <RecorteIdadeFilterPreview
                            idadeFilter={recorte.Filtros.idade}
                          />
                        )}
                        {recorte.Filtros?.listasCEP && (
                          <RecorteListaCEPFilterPreview
                            listaCEPFilter={recorte.Filtros.listasCEP}
                          />
                        )}
                        {recorte.Filtros?.listasDeduplicacao && (
                          <RecorteListasDeduplicacaoFilterPreview
                            listasDeduplicacaoFilter={
                              recorte.Filtros.listasDeduplicacao
                            }
                          />
                        )}
                        {recorte.Filtros?.localizacao && (
                          <RecorteLocalizacaoFilterPreview
                            localizacaoFilter={recorte.Filtros.localizacao}
                          />
                        )}
                        
                        {recorte.Filtros?.listasCidades && (
                          <ListasCidadesFilterPreview
                            listasCidadesFilterPreview={recorte.Filtros.listasCidades}
                            />
                        )}
                        {recorte.Filtros?.profissao && (
                          <RecorteProfissaoFilterPreview
                            profissaoFilter={recorte.Filtros.profissao}
                          />
                        )}
                        {recorte.Filtros?.rendaPresumidaAnual && (
                          <RecorteRendaAnualFilterPreview
                            rendaAnualFilter={
                              recorte.Filtros.rendaPresumidaAnual
                            }
                          />
                        )}
                        {recorte.Filtros?.rendaPresumidaMensal && (
                          <RecorteRendaMensalFilterPreview
                            rendaMensalFilter={
                              recorte.Filtros.rendaPresumidaMensal
                            }
                          />
                        )}
                        {recorte.Filtros?.scoreVeles && (
                          <RecorteScoreFilterPreview
                            scoreVelesFilter={recorte.Filtros.scoreVeles}
                          />
                        )}
                        {recorte.Filtros?.sexo && (
                          <RecorteSexoFilterPreview
                            sexoFilter={recorte.Filtros.sexo}
                          />
                        )}
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}

      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
      >
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja remover o recorte{" "}
            <strong>{recorteToRemove?.Nome}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={() => {
              if (recorteToRemove) {
                removeRecorte(recorteToRemove);
              }
              setOpenConfirmDialog(false);
              setRecorteToRemove(null);
            }}
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              "&:hover": { backgroundColor: theme.palette.primary.dark },
            }}
          >
            Remover
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
